import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  hours: number;
  label?: string;
  compact?: boolean;
}
export function Countdown({
  hours,
  label,
  compact = false
}: CountdownProps) {
  const {
    hours: hh,
    minutes,
    seconds
  } = useCountdown(hours);
  const boxClass = compact ? 'min-w-[2.75rem] px-2 py-1.5 text-xl sm:min-w-[3.25rem] sm:py-2 sm:text-2xl' : 'min-w-[3.25rem] px-2 py-2 text-2xl sm:min-w-[5.5rem] sm:px-3 sm:py-3 sm:text-4xl';
  return <div className="flex flex-col items-center" data-id="element-73" data-mp="3h1icnqaosz0j">
      {label ? <p className="text-center font-display text-[0.65rem] font-700 uppercase tracking-[0.18em] text-gold-400 sm:text-xs sm:tracking-[0.2em]" data-id="element-74" data-mp="3gymec0uxg8bk">
          {label}
        </p> : null}
      <div className="mt-2 flex items-center gap-1.5 sm:mt-3 sm:gap-2" role="timer" aria-live="off" aria-label={`Quedan ${hh} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-75" data-mp="374vsl3q6qbzk">
        {[hh, minutes, seconds].map((value, index) => <React.Fragment key={index} data-id="element-76" data-mp="xzvgd80sutyj" data-mpi={index}>
            {index > 0 ? <span className="font-display text-xl font-800 text-gold-400/70 sm:text-2xl" data-id="element-77" data-mp="t2llhcun5q3b">
                :
              </span> : null}
            <span className={['rounded-xl bg-teal-900/60 text-center font-display font-800 tabular-nums text-cream-50 ring-1 ring-cream-50/15', boxClass].join(' ')} style={{
          color: "#0C0E0E",
          backgroundColor: "#65F0B4",
          backgroundImage: "none"
        }} data-id="element-78" data-mp="17q6pra395vct">
              {value}
            </span>
          </React.Fragment>)}
      </div>
      <p className="mt-1.5 text-[0.6rem] uppercase tracking-[0.16em] text-cream-100/60 sm:mt-2 sm:text-xs sm:tracking-[0.18em]" data-id="element-79" data-mp="o2qvrcmlr6ju">
        Horas : Min : Seg
      </p>
    </div>;
}